import React from 'react'
import { getDateFormat } from '../../Config/functions'

export const SessionHistory = ({data}:any) => {

    return (
        <div className="col-sm-12 card py-5 mt-5">
            <div className="row">
                <div className="col-sm-12 px-4">
                    <h4>Session History</h4>
                
                    {data!=null && data.length >0 ?
                   
                   data.map((el:any) =>
                     (
                    <table className="table table-striped border-0 mt-4">
                        <tbody>
                            <tr>
                                <th scope="row">Session Date:</th>
                                <td>{el.session_date !== ""?getDateFormat(el.session_date) : ""}</td>
                                <th scope="row">Session Time:</th>
                                <td>{el.session_time}</td>
                                <th scope="row"> Session Expert:</th>
                                <td>{el.session_expert}</td>
                            </tr>
                        </tbody>
                    </table>)) : "No Session History Available "}
                    
                </div>
            </div>

        </div>
    )
}
